import { Routes } from '@angular/router';

export const clubAddRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./club-add.page').then((m) => m.ClubAddPage),
  },
];
